import { initialModel } from '@atlassian/help-center-common-util/model';
import type { ReqSla } from 'rest/models';
import type { UpdateReqSlasModelAction } from 'state/actions/req-slas';
import { UPDATE_REQ_SLAS_MODEL } from 'state/actions/req-slas';

export interface ReqSlasState {
	[requestKey: string]: ReqSla[];
}

export const getInitialReqSlasState = (): ReqSlasState => {
	const { reqDetails, reqSlas } = initialModel();

	return reqDetails && reqSlas ? { [reqDetails.key]: reqSlas } : {};
};

export const reqSlasReducer = (
	state: ReqSlasState = getInitialReqSlasState(),
	action: UpdateReqSlasModelAction,
): ReqSlasState => {
	switch (action.type) {
		case UPDATE_REQ_SLAS_MODEL:
			return {
				...state,
				[action.payload.requestKey]: action.payload.reqSlas,
			};
		default:
			return state;
	}
};
